import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";

import "./Aircraft.scss";
import AircraftStat from "./../../components/AircraftStat";
import mat4 from "./../../img/aircraft/mat4.jpg";
import mat7_cad from "./../../img/aircraft/auton_cad.png";

export default function AircraftAuton() {
  const tdrEmbedUrl = "https://drive.google.com/file/d/1NcUIrCezCr5aZab9XZqqOoFnLpMPyzRd/preview";
  const cdrEmbedUrl =
    "https://docs.google.com/presentation/d/1TKYVUbzdgK0IOB_XUAAKU1gavBQaMyioxOBlnggRs9A/embed?start=false&loop=false&delayms=3000";
  const flightVideoUrl = "https://www.youtube.com/embed/-6brpnC49Qo";

  useEffect(() => {
    AOS.init({
      easing: "ease",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Auton Aircraft | M-Fly</title>
      </Helmet>
      <div className="Aircraft">
        <div className="white-div">
          <h1 className="aircraft-name text-center">Autonomous</h1>
          <div className="highlights-grid">
            <div className="highlight-card">
              <h3>Competition</h3>
              <p>The Autonomous aircraft competes in the prestigious Student Unmanned Aerial Systems (SUAS) competition hosted by RoboNation, designed to test autonomous navigation, target detection, and precision payload delivery.</p>
            </div>
            <div className="highlight-card">
              <h3>Team Structure</h3>
              <p>Led by a chief engineer and organized into 10 technical leads with dedicated subteam members covering avionics, power systems, airframe, and computer vision.</p>
            </div>
            <div className="highlight-card">
              <h3>Key Capabilities</h3>
              <p>Autonomous GPS waypoint navigation with collision avoidance, onboard computer vision for target identification, and precision payload deployment matched to individual ground markers.</p>
            </div>
            <div className="highlight-card">
              <h3>2025 Achievement</h3>
              <p>Placed 18th out of 81 registered teams in first competition flight, scoring points and establishing a strong foundation for growth with a new QuadPlane configuration in 2026.</p>
            </div>
          </div>
        </div>

        <div className="blue-div">
          <div className="clearfix aircraft-container">
            {/* <img
              src={mat4}
              alt="MAT-5"
              className="float-left"
              data-aos="fade-right"
              data-aos-easing="ease"
              data-aos-duration="2000"
            /> */}
            <div className="media-placeholder">
                MAT-7 image coming soon!
            </div>
            <div className="info">
              <h1 className="aircraft-name text-center">MAT-7</h1>
              <p className="aircraft-description">
                The MAT-7 is a fully autonomous aircraft designed to compete in
                the Student Unmanned Aerial Systems (SUAS) Competition in 2026.
                Made out of carbon fiber composites and 3D
                printed parts, the MAT-7 is equipped with the Pixhawk 6X as its
                flight controller and the Jetson Orin Nano as its onboard
                computer. It is the Autonomous team's first VTOL aircraft, utilizing a 
                quadplane configuration to achieve vertical takeoff and landing capabilities 
                while maintaining efficient forward flight. It is designed to disassemble and fit 
                fully within a checked suitcase.
              </p>
            </div>
          </div>
          <div className="stats">
            <AircraftStat value="22 lbs" label="empty weight" />
            <AircraftStat value="28 lbs" label="max takeoff weight" />
            <AircraftStat value="6 ft" label="wingspan" />
            <AircraftStat value="~29 m/s" label="max flight speed" />
          </div>
        </div>

        <div className="white-div">
          <h2 className="aircraft-name text-center">Design Info</h2>
          <div className="design-grid">
            <div className="media-placeholder">
                <img src={mat7_cad} alt="MAT-7 CAD" className="cad-image" />
            </div>
            <div className="design-details">
              <div className="design-cards">
                <div className="design-card">
                  <h4>Airfoil</h4>
                  <p>Clark Y</p>
                </div>
                <div className="design-card">
                  <h4>Propulsion</h4>
                  <p>Quadrotor VTOL with tractor cruise propulsion</p>
                </div>
                <div className="design-card">
                  <h4>Manufacturing</h4>
                  <p>Infusion layups, full carbon skin wing</p>
                </div>
                <div className="design-card">
                  <h4>Key Hardware</h4>
                  <p>Pixhawk-Jetson baseboard, custom power distribution board</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="blue-div">
          <h2 className="aircraft-name text-center">Technical Report and Design Review</h2>
          <div className="embed-grid">
            <div className="embed-card">
                <iframe
                  src={tdrEmbedUrl}
                  title="TDR PDF"
                  frameBorder="0"
                />

            </div>
            <div className="embed-card">
              <iframe
                src={cdrEmbedUrl}
                title="CDR Slides"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </div>
        </div>


        <div className="white-div">
          <h2 className="aircraft-name text-center">Flight Video</h2>
          <iframe className="FRR" width="550" height="450" src="https://www.youtube.com/embed/-6brpnC49Qo?si=STjvsrPGJsq46BtJ" title="University of Michigan - Ann Arbor M-Fly Aero Design SUAS FRR 202" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
        
      </div>
    </>
  );
}
